import React from 'react';
import {Grid, Stack} from '@mui/material';
import FormikCheckbox from 'components/inputs/FormikCheckbox';
import FormikDatePicker from 'components/inputs/FormikDatePicker';
import FormikDropdown from 'components/inputs/FormikDropdown';
import FormikSwitch from 'components/inputs/FormikSwitch';
import {ReportRelativeTimeRangeTypeNames} from 'types/diplomat/reports/ReportRelativeTimeRangeType';
import {enums} from 'types/enums';
import {useFieldValueGetter} from 'components/hook-form/useFieldValueGetter';
import {useTranslation} from 'react-i18next';
import {
   CommonReportParamsNames,
   ICommonReportParams,
} from 'types/diplomat/reports/CommonReportParams';

export const ByDateReportTypeFormPart = () => {
   const {t} = useTranslation();

   const getValue = useFieldValueGetter<ICommonReportParams>();
   const enabled = !getValue('allRecords');
   const byDate = getValue('byDate');
   const relativeDate = getValue('relativeDate');

   return (
      <>
         <Grid item sm={3}>
            <FormikCheckbox
               name={CommonReportParamsNames.byDate}
               label={t('By Date:')}
               disabled={!enabled}
            />
         </Grid>
         <Grid item xs={8}>
            <Stack>
               <div>
                  <FormikSwitch
                     name={ReportRelativeTimeRangeTypeNames.relativeDate}
                     labels={[t('Fixed'), t('Relative')]}
                     disabled={!enabled || !byDate}
                  />
               </div>
               <Stack direction="row" spacing={3}>
                  <div>
                     <FormikDatePicker
                        name={CommonReportParamsNames.fromDate}
                        label={t('From')}
                        disabled={!enabled || !byDate || relativeDate}
                     />
                  </div>
                  <div>
                     <FormikDatePicker
                        name={CommonReportParamsNames.toDate}
                        label={t('To')}
                        disabled={!enabled || !byDate || relativeDate}
                     />
                  </div>
               </Stack>
               <div>
                  <FormikDropdown
                     name={ReportRelativeTimeRangeTypeNames.relativeDateType}
                     options={enums.TimeRangeReportType.options}
                     disabled={!enabled || !byDate || !relativeDate}
                  />
               </div>
            </Stack>
         </Grid>
      </>
   );
};
